(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  class TabbedCollections {
    constructor(container) {
      this.container = container;
      this.tabs = container.querySelectorAll('.tabbed-collections__tab');
      this.panels = container.querySelectorAll('.tabbed-collections__panel');
      this.init();
    }

    init() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchTab(tab.dataset.tab);
        });
      });
      // 初期表示のパネル内の画像も確実に表示させる
      this.markSlidesVisible(this.container.querySelector('.tabbed-collections__panel--active'));
    }

    loadPanel(panel) {
      if (!panel || panel.dataset.loaded === 'true') return;
      const template = panel.querySelector('template.tabbed-collections__panel-template');
      if (template) {
        panel.appendChild(template.content.cloneNode(true));
        template.remove();
      }
      panel.dataset.loaded = 'true';
    }

    markSlidesVisible(panel) {
      if (!panel) return;
      panel.querySelectorAll('slideshow-component').forEach((slideshow) => {
        slideshow.setAttribute('actioned', '');

        // タブ切替後にスライドの状態が更新されないケースの対策
        if (typeof slideshow.select === 'function') {
          requestAnimationFrame(() => slideshow.select(0, undefined, { animate: false }));
          return;
        }

        const slides = slideshow.querySelectorAll('slideshow-slide');
        slides.forEach((slide, index) =>
          slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true')
        );
      });
    }

    switchTab(tabId) {
      // すべてのタブとパネルを非アクティブにする
      this.tabs.forEach(tab => {
        tab.classList.remove('tabbed-collections__tab--active');
      });
      
      this.panels.forEach(panel => {
        panel.classList.remove('tabbed-collections__panel--active');
      });

      // 選択されたタブとパネルをアクティブにする
      const activeTab = this.container.querySelector(`[data-tab="${tabId}"]`);
      const activePanel = this.container.querySelector(`.tabbed-collections__panel[data-tab="${tabId}"]`);
      
      if (activeTab) {
        activeTab.classList.add('tabbed-collections__tab--active');
      }
      
      if (activePanel) {
        this.loadPanel(activePanel);
        activePanel.classList.add('tabbed-collections__panel--active');
        // タブ切替直後に画像が非表示になるのを防ぐ
        requestAnimationFrame(() => this.markSlidesVisible(activePanel));
      }
    }
  }

  const initTabbedCollections = (root = document) => {
    const tabbedCollections = root.querySelectorAll('.section-tabbed-collections');
    tabbedCollections.forEach(container => {
      if (container.dataset.tabbedCollectionsInit === 'true') return;
      container.dataset.tabbedCollectionsInit = 'true';
      new TabbedCollections(container);
    });
  };

  // 初期化（DOMContentLoaded前後どちらでも確実に動くようにする）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTabbedCollections());
  } else {
    initTabbedCollections();
  }

  // テーマエディタなどでセクションが再読み込みされた場合の再初期化
  document.addEventListener('shopify:section:load', (event) => {
    if (!event?.target) return;
    initTabbedCollections(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
